import { Tooltip } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import RenderStatus from "../../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { StyledTooltip } from "../../../styles/styledTooltip";

const CashFlowSwapList = ({ swaps, notification, setNotification }) => {
  const { t } = useTranslation("cashFlow");

  if (!swaps) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (swaps.length === 0) {
    return <Alert severity="warning">{t("swap.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="swap-table_scroll">
      <StyledTable
        width="2255"
        size="14"
        className="swap-table"
      >
        <StyledTableHead
          col="12"
          scroll="auto"
          className="swap-table__head"
        >
          <div>
            Id
            <Tooltip
              title={t("swap.table.tooltips.id")}
              arrow
              placement="top"
            >
              <StyledTooltip className="icon-light-help" />
            </Tooltip>
          </div>
          <div>
            Reference id
            <Tooltip
              title={t("swap.table.tooltips.referenceId")}
              arrow
              placement="top"
            >
              <StyledTooltip className="icon-light-help" />
            </Tooltip>
          </div>
          <div>
            {t("swap.table.user")}
          </div>
          <div>
            {t("swap.table.project")}
          </div>
          <div>
            {t("swap.table.inService")}
          </div>
          <div>
            {t("swap.table.inAmount")}
          </div>
          <div>
            {t("swap.table.outService")}
          </div>
          <div>
            {t("swap.table.outAmount")}
          </div>
          <div>
            {t("swap.table.status")}
          </div>
          <div>
            {t("swap.table.createdAt")}
          </div>
          <div>
            {t("swap.table.updatedAt")}
          </div>
          <div>
            {t("swap.table.note")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {swaps.map((item, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="12"
              className="swap-table__row"
              cursor="pointer"
            >
              <StyledCol
                inline
                data-title="id"
              >
                <CopyToClipboard
                  text={item.id}
                  onCopy={() => {
                    setNotification({ ...notification, visible: true, type: "success", message: t("swap.table.copied") });
                  }}
                >
                  <StyledBreakWord as="p">
                    {item.id} <StyledCopy
                    title={t("swap.table.copy")}
                    className="icon-light-copy"
                  />
                  </StyledBreakWord>
                </CopyToClipboard>
              </StyledCol>
              <StyledCol
                inline
                data-title="Reference id"
              >
                <CopyToClipboard
                  text={item.referenceId}
                  onCopy={() => {
                    setNotification({ ...notification, visible: true, type: "success", message: t("swap.table.copied") });
                  }}
                >
                  <StyledBreakWord as="p">
                    {item.referenceId} <StyledCopy
                    title={t("swap.table.copy")}
                    className="icon-light-copy"
                  />
                  </StyledBreakWord>
                </CopyToClipboard>
              </StyledCol>
              <StyledCol
                inline
                data-title={t("swap.table.user")}
              >
                <StyledBreakWord>
                  {item.inConnection.project.user.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.project")}
              >
                {item.inConnection.project.name}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.inService")}
              >
                {item.inConnection.service.name}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.inAmount")}
              >
                {item.inAmount} {item.inCurrency.asset} {item.inCurrency.asset === item.inPaymentSystem.subName ? null : `(${item.inPaymentSystem.subName})`}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.outService")}
              >
                {item.outConnection.service.name}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.outAmount")}
              >
                {item.outAmount} {item.outCurrency.asset} {item.outCurrency.asset === item.outPaymentSystem.subName ? null : `(${item.outPaymentSystem.subName})`}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("swap.table.status")}
              >
                <RenderStatus status={item.status.value} />
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.createdAt")}
              >
                {TimestampToDateMoment(item.createdAt)}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.updatedAt")}
              >
                {TimestampToDateMoment(item.updatedAt)}
              </StyledCol>
              <StyledCol
                data-title={t("swap.table.note")}
                className="swap-table__note"
              >
                <p className="note">
                  {item.note}
                </p>
                {item.note && item.note.length > 25 &&
                  <Tooltip
                    title={item.note}
                    arrow
                    placement="top"
                  >
                    <StyledTooltip className="icon-light-info" />
                  </Tooltip>}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default CashFlowSwapList;